import { render, staticRenderFns } from "./referFriend.vue?vue&type=template&id=a9cfcf20&scoped=true"
import script from "./referFriend.vue?vue&type=script&lang=js"
export * from "./referFriend.vue?vue&type=script&lang=js"
import style0 from "./referFriend.vue?vue&type=style&index=0&id=a9cfcf20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cfcf20",
  null
  
)

export default component.exports